// extracted by mini-css-extract-plugin
export default {"about":"About_about__lMA0E","aboutContent":"About_aboutContent__LpsJH","title":"About_title__EskS0"};